import React from "react";
import Comingsoonpage from "../../../common/Comingsoon";

const MiscUploads = () => {
  return (
    <div>
      <Comingsoonpage />
    </div>
  );
};

export default MiscUploads;
